import * as React from 'react'
import {useRef} from 'react'
import ScrollBar from 'react-perfect-scrollbar'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {
  calculatePrice,
  calculateUpgradePrice,
  paymentDaysLeft,
  PaymentStatus
} from 'yougile-model'
import {setDisplayName} from '@common/utils-ui'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {PageHeader} from '@components/page/page-header'
import {WithResizeObserver} from '@components/sticker/sticker-panel/resize-observer'
import {Requisites} from '@extensions/web-pay'
import {BillingBuy} from './billing-buy'
import {BillingHistory} from './billing-history'
import {BillingPay} from './billing-pay'
import {BillingStatus} from './billing-status'

export interface BillingProps {
  companyName: string
  paymentStatus: PaymentStatus
  license: {
    type: 'buy' | 'prolong' | 'add-users'
    months: 1 | 3 | 6 | 12
    users: number
    paymentMethod: 'card' | 'invoice'
    recurrent: boolean
    email: string
    phone: string
    error: string
    success: boolean
    wait: boolean
  }
  onChange: (newLicense: BillingProps['license']) => void
  onPayCard: () => void
  onRequestInvoice: (requisites: Requisites) => void
}

export const calcTotal = (props: BillingProps) => {
  const {license, paymentStatus} = props
  const daysLeft = paymentDaysLeft(paymentStatus)
  switch (license.type) {
    case 'buy':
      return calculatePrice(license.months, license.users)
    case 'prolong':
      return calculatePrice(license.months, paymentStatus.users)
    default:
      return calculateUpgradePrice(license.users, daysLeft)
  }
}

export const BillingBase = (props: BillingProps) => {
  const {companyName} = props
  const bem = Util.bemFrom('billing')
  const scrollContainer = useRef<ScrollBar>(null)
  const onResizeHeight = () => {
    if (scrollContainer.current) {
      scrollContainer.current.updateScroll()
    }
  }

  return (
    <div className={bem()}>
      <PageHeader>{Lang.msg.billingPageTitle}</PageHeader>
      <WithPerfectScrollbar
        scrollDirection="xy"
        className="flex-1"
        ref={scrollContainer}
      >
        <WithResizeObserver type="h" callback={onResizeHeight}>
          <div className={bem('page')}>
            <div className={bem('title')}>
              {Lang.msg.company} “{companyName}”
            </div>
            <BillingStatus {...props} />
            <BillingBuy {...props} />
            <BillingPay {...props} />
            <BillingHistory {...props.paymentStatus} />

            <div className={bem('footer')}>{Lang.msg.billingYouGileInfo}</div>
          </div>
        </WithResizeObserver>
      </WithPerfectScrollbar>
    </div>
  )
}

setDisplayName(BillingBase, 'BillingBase')
